import { Magnetic as Mi } from '../../styles';
import styled from '@emotion/styled';
export const StyledUploadListContainer = styled.div `
	width: 100%;
	height: 100%;
	background-color: ${Mi.colorWhite};
	font-family: ${Mi.baseFontFamily};
	overflow: hidden;
`;
export const StyledListItem = styled.li `
	display: flex;
	position: relative;
	align-items: center;
	font-size: ${Mi.fontSize14};
	padding: ${Mi.spacer12} 0;
	margin: 0 ${Mi.spacer40};
	@media (max-width: ${Mi.layoutBreakpointSm}) {
		 {
			flex-direction: column;
		}
	}
`;
export const StyledFileUploadItem = styled.div `
	width: 100%;
	display: flex;
	align-items: center;
`;
export const StyledRetryButtonContainer = styled.div `
	flex: 1 1 10%;
	> button {
		&:hover {
			background-color: transparent;
		}
	}
`;
export const StyledErrorMessageMobileView = styled('div') `
	margin-top: ${Mi.spacer06};
	align-self: flex-start;
	width: 100%;
`;
export const StyledListItemWithBorder = styled.li `
	display: flex;
	position: relative;
	padding: ${Mi.spacer12} 0;
	border-bottom: ${Mi.baseBorderStyle} ${Mi.baseBorderWidth} ${Mi.colorNeutral20};
	align-items: center;
	font-size: ${Mi.fontSize14};
`;
export const StyledThumbnailDiv = styled.div `
	height: min-content;
	margin-top: ${Mi.spacer04};
	border: ${Mi.baseBorderStyle} ${Mi.baseBorderWidth} ${Mi.colorNeutral30};
`;
export const StyledImage = styled.img `
	height: 50px;
	width: 50px;
`;
export const StyledFileInfo = styled.div `
	padding: ${Mi.spacer04} 0px 0px ${Mi.spacer12};
	flex: 1 1 40%;
	max-height: 100%;
	overflow: hidden;
`;
export const StyledText = styled.span `
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
export const StyledErrorText = styled('span') `
	color: ${Mi.annotationAlertColor};
	margin-top: ${Mi.spacer08};
	@media (min-width: ${Mi.layoutBreakpointSm}) {
		 {
			display: block;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
`;
export const StyledFailedFilesCountText = styled('span') `
	color: ${Mi.annotationAlertColor};
`;
export const StyledFileSizeContainer = styled.div `
	height: 100%;
	flex: 1 1 20%;
	text-align: right;
	justify-content: center;
	display: flex;
	align-items: center;
`;
export const StyledFileSize = styled.span `
	flex: 0 1 50%;
`;
export const StyledStatusIcon = styled.span `
	font-size: ${Mi.fontSize18};
	margin-right: ${Mi.spacer04};
`;
export const StyledImageContainer = styled.div `
	height: 50px;
	width: 50px;
	margin: ${Mi.spacer04};
	background-color: ${Mi.colorNeutral20};
`;
export const StyledErrorHeader = styled.span `
	font-weight: ${Mi.fontWeightSemibold};
	font-size: ${Mi.fontSize16};
`;
export const StyledFileUploadErrorList = styled.ul `
	color: ${Mi.baseFontColor};
	list-style-type: disc;
	list-style-position: inside;
	white-space: normal;
`;
export const StyledUploadModalContent = styled.div `
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
`;
export const StyledUploadModalHeaderLabel = styled.label `
	font-size: ${Mi.fontSize14};
	font-family: ${Mi.baseFontFamily};
	font-weight: ${Mi.fontWeightNormal};
	color: ${Mi.colorNeutral80};
`;
export const StyledUploadModalSwitchContainer = styled.div `
	display: inline-block;
	position: absolute;
	right: 0;
	padding-right: ${Mi.spacer20};
	margin-top: ${Mi.spacer16};
`;
export const StyledUploadModalTextContainer = styled.div `
	display: block;
`;
export const StyledUploadModalHeaderContainer = styled.div `
	display: inline-block;
`;
export const StyledUploadModalHeaderSubtitle = styled.span `
	font-size: ${Mi.fontSize14};
	font-weight: ${Mi.fontWeightNormal};
	display: block;
`;
export const StyledUploadModalHeaderTitle = styled.span `
	font-size: ${Mi.fontSize18};
	font-weight: ${Mi.fontWeightHeavy};
`;
export const StyledProgressBarContainer = styled.div `
	flex: 1 1 30%;
	padding-left: ${Mi.spacer20};
	padding-right: ${Mi.spacer20};
`;
export const StyledCancelIcon = styled.span `
	color: ${Mi.colorBrand40};
	cursor: pointer;
	font-size: ${Mi.fontSize18};
`;
export const StyledCancelIconContainer = styled.div `
	flex: 1 1 10%;
`;
//# sourceMappingURL=styles.js.map